var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#555D64","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2932 20.3382C9.90269 20.7287 9.90269 21.3619 10.2932 21.7524C10.6837 22.1429 11.3169 22.1429 11.7074 21.7524L16.3027 17.1571L20.8981 21.7525C21.2887 22.143 21.9218 22.143 22.3124 21.7525C22.7029 21.362 22.7029 20.7288 22.3124 20.3383L17.7169 15.7429L21.7525 11.7074C22.143 11.3168 22.143 10.6837 21.7525 10.2931C21.3619 9.90261 20.7288 9.90261 20.3382 10.2931L16.3027 14.3287L12.2673 10.2932C11.8768 9.90272 11.2436 9.90272 10.8531 10.2932C10.4626 10.6838 10.4626 11.3169 10.8531 11.7075L14.8885 15.7429L10.2932 20.3382Z","fill":"white"}))]);
}

CloseInline.defaultProps = {"viewBox":"0 0 32 32","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
